import { Injectable, TemplateRef } from '@angular/core';
import { BaseControl, Textbox, Custom, Container, TextArea, Static } from '@app/shared';
import { Validators } from '@angular/forms';
import { find } from 'lodash';

@Injectable()
export class DocumentDependencyFormService {

  constructor() { }

  /**
   * Construye y retorna el formulario para agregar o modificar la valoracion de un documento
   *
   * @param {TemplateRef<any>} templateUpload
   * @returns {BaseControl<any>[]}
   * @memberof DocumentDependencyFormService
   */
  getFormDocumentDependency(
    templetesFomr: any,
    objectModel: any,
    data: any
  ): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Custom({
        key: 'dependencia',
        label: 'Dependencia',
        size: 'col-12 col-lg-12',
        value: objectModel ? objectModel.dependencia ? objectModel.dependencia.id : null : null, 
        template: templetesFomr['select'],
        options: data ? data['dependencia'] : [],
        placeholder: 'Seleccione la dependencia',
        validations: {
          validators: [Validators.required]
        }
      }),
      new Custom({
        key: 'serie',
        label: 'Serie',
        value: objectModel ? objectModel.serie ? objectModel.serie.id : null : null, 
        size: 'col-12 col-lg-12',
        options: data ? data['serie'] : [],
        template: templetesFomr['serie'],
        placeholder: 'Seleccione la serie',
        validations: {
          validators: [Validators.required]
        }
      }),
      new Custom({
        key: 'subserie',
        label: 'Subserie',
        size: 'col-12 col-lg-12',
        value: objectModel ? objectModel.subserie ? objectModel.subserie.id : null : null, 
        template: templetesFomr['subserie'],
        options: data ? data['subserie'] : [],
        placeholder: 'Seleccione la subserie',
        validations: {
          validators: []
        },
        condictions: [
          {
            campoDepende: 'serie',
            siEs: 'Vacio',
            accion: 'Bloquear'
          }
        ]
      }),
      // new Custom({
      //   key: 'tipo_documental',
      //   label: 'Tipo documental',
      //   size: 'col-12 col-lg-12',
      //   value: objectModel ? objectModel.tipo_documental ? objectModel.tipo_documental.id : null : null, 
      //   template: templetesFomr['tipo_documental'],
      //   options: data ? data['tipo_documental'] : [],
      //   placeholder: 'Seleccione el tipo documental',
      //   validations: {
      //     validators: [Validators.required]
      //   },
      //   condictions: [
      //     {
      //       campoDepende: 'subserie',
      //       siEs: 'Vacio',
      //       accion: 'Bloquear'
      //     }
      //   ]
      // }),
    ];
    

    return controls.sort((a, b) => a.order - b.order);
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/documents/document-dependency/shared/document-dependency-form.service.ts